import { render } from "./OperatorPage.vue?vue&type=template&id=0c200272&ts=true"
import script from "./OperatorPage.vue?vue&type=script&lang=ts"
export * from "./OperatorPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__